import { ApartmentOutlined, ContactsOutlined, FieldBinaryOutlined, MinusOutlined, TagOutlined, UserOutlined } from "@ant-design/icons";
import { Col, Divider, Row, Space, Typography } from "antd";
import React from "react";

const { Text, Link } = Typography;
const type = "secondary";

export default function Sidebar({ selectedManufacturer, selectedClient, selectedProduct, labelCount, selectedRecipient }) {
   return (
      <>
         <Row>
            {/* MANUFACTURER */}
            {selectedManufacturer && (
               <>
                  <Col span={24}>
                     <Space>
                        <ApartmentOutlined />
                        <Text ellipsis>Manufcaturer :</Text>
                        <Text ellipsis type={type}>
                           {selectedManufacturer.company}
                        </Text>
                     </Space>
                  </Col>
                  <Divider />
               </>
            )}
            {/* CLIENT */}
            {selectedClient && (
               <>
                  <Col span={24}>
                     <Space>
                        <UserOutlined />
                        <Text ellipsis>Client :</Text>
                        <Text ellipsis type={type}>
                           {selectedClient.client}
                        </Text>
                     </Space>
                  </Col>
                  <Col span={24}>
                     <Space>
                        <MinusOutlined />
                        <Text ellipsis>VAT :</Text>
                        <Text ellipsis type={type}>
                           {selectedClient.vat}
                        </Text>
                     </Space>
                  </Col>

                  {selectedClient.clientGroup && (
                     <>
                        <Col span={24}>
                           <Space>
                              <MinusOutlined />
                              <Text ellipsis>Group :</Text>
                              <Text ellipsis type={type}>
                                 {selectedClient.clientGroup}
                              </Text>
                           </Space>
                        </Col>
                     </>
                  )}

                  <Divider />
               </>
            )}
            {/* PRODUCT */}
            {selectedProduct && (
               <>
                  <Col span={24}>
                     <Space>
                        <TagOutlined />
                        <Text ellipsis>Product :</Text>
                        <Text type={type}>{selectedProduct.product.productName}</Text>
                     </Space>
                  </Col>

                  <Col span={24}>
                     <Space>
                        <MinusOutlined />
                        <Text>Knife :</Text>
                        <Text type={type}>{selectedProduct.knifeCode}</Text>
                     </Space>
                  </Col>
                  <Col span={24}>
                     <Space>
                        <MinusOutlined />
                        <Text ellipsis>Width/Height :</Text>
                        <Text ellipsis type={type}>
                           {" "}
                           {selectedProduct.labelWidth + " / " + selectedProduct.labelHeight}
                        </Text>
                     </Space>
                  </Col>
                  <Col span={24}>
                     <Space>
                        <MinusOutlined />
                        <Text ellipsis>Machine :</Text>
                        <Text ellipsis type={type}>
                           {selectedProduct.machine}
                        </Text>
                     </Space>
                  </Col>
                  <Col span={24}>
                     <Space>
                        <MinusOutlined />
                        <Text ellipsis>Material :</Text>
                        <Text ellipsis type={type}>
                           {selectedProduct.material}
                        </Text>
                     </Space>
                  </Col>
                  <Col span={24}>
                     <Space>
                        <MinusOutlined />
                        <Text ellipsis>Number of Columns :</Text>
                        <Text ellipsis type={type}>
                           {selectedProduct.numberOfColumns}
                        </Text>
                     </Space>
                  </Col>
                  {selectedProduct.product.productFileUrl && (
                     <>
                        <Col span={24}>
                           <Space>
                              <MinusOutlined />
                              <Text ellipsis>File :</Text>
                              <Link target="_blank" href={selectedProduct.product.productFileUrl}>
                                 Link
                              </Link>
                           </Space>
                        </Col>
                     </>
                  )}
                  <Divider />
               </>
            )}
            {/* LABEL COUNT */}
            {labelCount && Object.keys(labelCount).length !== 0 && (
               <>
                  <Col span={24}>
                     <Space>
                        <FieldBinaryOutlined />
                        <Text ellipsis>Label Count :</Text>
                        <Text ellipsis type={type}>
                           {labelCount.quantity}
                        </Text>
                     </Space>
                  </Col>
                  <Col span={24}>
                     <Space>
                        <MinusOutlined />
                        <Text>Price :</Text>
                        <Text type={type}>{labelCount.price}</Text>
                     </Space>
                  </Col>
                  <Col span={24}>
                     <Space>
                        <MinusOutlined />
                        <Text ellipsis>Weight :</Text>
                        <Text ellipsis type={type}>
                           {labelCount.labelWeight + " (KG)"}
                        </Text>
                     </Space>
                  </Col>
                  <Divider />
               </>
            )}
            {/* RECIPIENT */}
            {selectedRecipient && (
               <>
                  <Col span={24}>
                     <Space>
                        <ContactsOutlined />
                        <Text ellipsis>Recipient :</Text>
                        <Text ellipsis type={type}>
                           {selectedRecipient}
                        </Text>
                     </Space>
                  </Col>
               </>
            )}
         </Row>
      </>
   );
}
